import React, { Fragment } from "react";

import {
  Card,
  CardActions,
  CardContent,
  Divider,
  Grid,
  makeStyles,
  useMediaQuery,
  useTheme,
} from "@material-ui/core";
import { Skeleton } from "@material-ui/lab";
import { times } from "lodash";

const useStyles = makeStyles(theme => ({
  card: {
    minHeight: "91px",
  },
  contentContainer: {
    padding: theme.spacing(3, 2),
  },
  actionContainer: {
    padding: theme.spacing(2),
    justifyContent: "flex-end",
  },
  buttonContainer: {
    float: "right",
  },
}));

const AreaSkeleton: React.FC = () => {
  const classes = useStyles();

  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Grid container spacing={3}>
      {times(4).map(index => (
        <Grid item xs={12} key={index}>
          <Card className={classes.card}>
            <CardContent className={classes.contentContainer}>
              <Grid
                container
                alignItems="center"
                direction="row"
                justify="space-between"
                spacing={2}
              >
                <Grid item xs={12} sm={3}>
                  <Grid
                    container
                    direction="row"
                    alignItems="center"
                    spacing={1}
                  >
                    <Grid item>
                      <Skeleton variant="circle" height={45} width={45} />
                    </Grid>
                    <Grid item xs={5}>
                      <Skeleton variant="text" height={30} width="100%" />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={6} sm={2}>
                  <Grid container direction="column">
                    <Grid item>
                      <Skeleton variant="text" width="80%" />
                      <Skeleton variant="text" width="50%" />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={3} sm={2}>
                  <Grid container direction="column">
                    <Grid item>
                      <Skeleton variant="text" width="80%" />
                      <Skeleton variant="text" width="50%" />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={3} sm={2}>
                  <Grid container direction="column">
                    <Grid item>
                      <Skeleton variant="text" width="80%" />
                      <Skeleton variant="text" width="50%" />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={3} sm={2}>
                  <Grid container direction="column">
                    <Grid item>
                      <Skeleton variant="text" width="80%" />
                      <Skeleton variant="text" width="50%" />
                    </Grid>
                  </Grid>
                </Grid>
                {!isMobile && (
                  <Grid item xs={1}>
                    <Skeleton
                      variant="rect"
                      height={35}
                      width={60}
                      className={classes.buttonContainer}
                    />
                  </Grid>
                )}
              </Grid>
            </CardContent>
            {isMobile && (
              <Fragment>
                <Divider />
                <CardActions className={classes.actionContainer}>
                  <Skeleton variant="rect" height={35} width={60} />
                </CardActions>
              </Fragment>
            )}
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default AreaSkeleton;
